.back-to-merchant {
  display: flex;
  justify-content: center;
  gap: 1rem;

  border: 1px solid oklch(0.4733 0.0611 267);
  border-radius: 8px;
  margin-top: 1rem;
  padding: 1rem;

  color: oklch(0.2436 0.0611 267.12);
  font-size: 1.4rem;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    background-color: oklch(0.2436 0.0611 267.12);
    border-color: oklch(0.2436 0.0611 267.12);
    color: whitesmoke;
  }
}